import React, { FunctionComponent, lazy, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router'
import { NoMatch } from '../etc/NoMatch'
import { ROUTES } from '../../../http/routes'
import { flow } from 'fp-ts/es6/function'
import { urlWithParams, urlWithQuery } from '../../../http/utils'
import { useRootDispatch, useRootSelector } from '../../../utils/hooks'
import OkCancel from '../../controls/OkCancel/OkCancel'
import { Dialog } from '../../etc/Dialog/Dialog'
import { projectActions } from '../../../redux/data/project/project-actions'
import ProjectList from './ProjectList/ProjectList'
import { Colors } from '../../../styles'
import { ProjectEditState } from '../../../redux/data/project/project-reducer'

const ProjectNew = lazy(() => import('./ProjectEdit/ProjectEdit'))
const ProjectPage = lazy(() => import('./ProjectPage/ProjectPage'))

const ProjectsPage: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const projectEditState = useRootSelector(state => state.data.project.editState)

    return <Suspense fallback={<div/>}>
        <Switch>
            <Route
                exact
                path={ROUTES.OBJECT}
                render={({ match: { params } }) => <Redirect to={flow(
                    urlWithParams({ projectId: params.projectId }),
                    urlWithQuery({ object: params.objectId })
                )(ROUTES.PROJECT_DETAIL)}/>}
            />
            <Route
                exact
                path={ROUTES.PROJECTS}
                component={ProjectList}
            />
            <Route
                exact
                path={ROUTES.PROJECTS_NEW}
                component={ProjectNew}
            />
            <Route
                exact
                path={ROUTES.PROJECTS_EDIT}
                component={ProjectNew}
            />
            <Route
                path={ROUTES.PROJECT_DETAIL}
                component={ProjectPage}
            />
            <NoMatch/>
        </Switch>
        {
            ProjectEditState.is.cancel(projectEditState) && <Dialog
                header={'Подтвердите отмену проекта: ' + projectEditState.project.name}
                onClose={() => dispatch(projectActions.cancelEdit())}
                actions={({ onClose }) => <OkCancel
                    color={Colors.red}
                    onOk={() => dispatch(projectActions.cancel.request())}
                    onCancel={onClose}
                    text={'Отменить проект'}
                />}
            />
        }
    </Suspense>
}

export default ProjectsPage